Vue.config.delimiters = ["${", "}"];
Vue.config.unsafeDelimiters = ["{!!", "!!}"];
